import { FC, ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';
import moment from 'moment';

import { primaryColors } from '~components/theme/styles/colors';

export const DateContainer: FC<{ unixTime: number; children: ReactNode }> = ({ unixTime, children }) => {
  const UNIX_TIMESTAMP = unixTime;
  const LOCAL_TIMESTAMP = moment.unix(UNIX_TIMESTAMP).utcOffset(new Date().getTimezoneOffset());

  return (
    <Stack spacing={0.5}>
      <Typography variant="label3" color={primaryColors[900]}>
        <i>Posted on: {`${LOCAL_TIMESTAMP.format('L')}`}</i>
      </Typography>
      {children}
    </Stack>
  );
};

export const DateInstance: FC<{ unixTime: number }> = ({ unixTime }) => {
  const NITRO_UNIX_TIMESTAMP = unixTime;
  const LOCAL_TIMESTAMP = moment.unix(NITRO_UNIX_TIMESTAMP).utcOffset(new Date().getTimezoneOffset());

  return <>{`${LOCAL_TIMESTAMP.format('MMMM Do YYYY, hA')}`}</>;
};
